import { render, staticRenderFns } from "./WaterPlantArea.vue?vue&type=template&id=bf701284&scoped=true"
import script from "./WaterPlantArea.vue?vue&type=script&lang=js"
export * from "./WaterPlantArea.vue?vue&type=script&lang=js"
import style0 from "./WaterPlantArea.vue?vue&type=style&index=0&id=bf701284&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf701284",
  null
  
)

export default component.exports